import type { AppEnvironment } from './environment.model';

// Shared development environment for the hosted dev.mkzs.tech frontend and apidev.mkzs.tech API.
export const environment: AppEnvironment = {
  production: false,
  apiBaseUrl: 'https://apidev.mkzs.tech/api/v1',
  assetBaseUrl: 'https://assetsdev.mkzs.tech/portfolio-images',
  appInsightsConnectionString: '__APPINSIGHTS_CONNECTION_STRING__',
  entraExternalId: {
    provider: 'Microsoft Entra External ID',
    enabled: true,
    tenantId: '432bbacb-fce7-413e-ae63-d7cce388a124',
    tenantName: 'devmkzs',
    clientId: '80fe8bdb-ed64-4ea6-be90-03e07aac24a5',
    authority: 'https://devmkzs.ciamlogin.com/432bbacb-fce7-413e-ae63-d7cce388a124',
    knownAuthorities: ['devmkzs.ciamlogin.com'],
    redirectUri: 'https://dev.mkzs.tech/',
    postLogoutRedirectUri: 'https://dev.mkzs.tech/',
    apiBaseUrl: 'https://apidev.mkzs.tech/api/v1',
    apiScopes: ['api://18480a3c-c905-45bc-9af9-9c3ced6951d1/access_as_user'],
    signUpSignInPolicyId: 'B2C_1_signup_signin',
    enableLocalAccounts: true,
    brandedDomain: 'mkzs.tech',
    portalAdminGroupId: '2097f62c-b6b2-4f13-aaf6-4877ac9c4ca8'
  }
};
